import React from 'react';
import { Input } from '@ui';

interface ToggleSwitchProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  labelStacked?: boolean;
  hint?: React.ReactNode;
  hintClassName?: string;
  hintId?: string;
  hintHidden?: boolean;
  disabled?: boolean;
  name?: string;
  className?: string;
}

const ToggleSwitch = React.forwardRef<HTMLInputElement, ToggleSwitchProps>(
  (
    {
      id,
      checked,
      onChange,
      label,
      labelStacked = false,
      hint,
      hintClassName,
      hintId,
      hintHidden,
      disabled,
      name,
      className = '',
    },
    ref
  ) => {
    return (
      <>
        {labelStacked && label ? <span className='toggle-switch-label'>{label}</span> : null}
        <label className={['toggle-switch', className].filter(Boolean).join(' ')}>
          <Input
            ref={ref}
            id={id}
            name={name}
            type='checkbox'
            role='switch'
            aria-checked={checked}
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
            hintClassName={hintClassName}
            hintId={hintId}
            hintHidden={hintHidden}
          />
          <span className='track'>
            <span className='thumb'></span>
          </span>
          {!labelStacked && label ? <span className='toggle-switch-label'>{label}</span> : null}
        </label>
        {hint ? <small className='hint'>{hint}</small> : null}
      </>
    );
  }
);

ToggleSwitch.displayName = 'ToggleSwitch';

export default ToggleSwitch;
